module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "reauthenticate",
    staticClass: "reauthenticate-modal",
    on: {
      "open": _vm.opened,
      "close": _vm.closed
    }
  }, [_c('md-dialog-title', [_c('div', {
    staticClass: "modal-title"
  }, [_vm._v("Reauthenticate")])]), _vm._v(" "), _c('md-dialog-content', {
    staticClass: "reauthenticate-modal-content"
  }, [(_vm.user.signInMethod === 'email') ? _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('md-input-container', {
    attrs: {
      "md-has-password": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.reAuthByEmail
    }
  }, [_c('md-icon', [_vm._v("mail")]), _vm._v(" Reauthenticate")], 1)], 1) : _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.reAuthByGoogle
    }
  }, [_c('md-icon', [_vm._v("person")]), _vm._v(" Reauthenticate")], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5615a656","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/reauthenticate.vue
// module id = 1245
// module chunks = 21